import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { AREAS, C } from "./constants";
import { PainInput } from "./PainInput";
import { Capa3Matrix } from "./Capa3Matrix";
import { Capa3Cards } from "./Capa3Cards";

export const Capa3Section = ({ testId, data, onSaved }) => {
  const [dolor, setDolor] = useState(data.dolor || {});
  const [editing, setEditing] = useState(!data.result);
  const [saving, setSaving] = useState(false);
  const complete = AREAS.every((a) => dolor[a.code]);

  async function save() {
    setSaving(true);
    try {
      const r = await api.put(`/consulting/tests/${testId}/tablero/capa3`, { dolor });
      onSaved(r.data);
      setEditing(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No pudimos guardar tus respuestas");
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="rounded-2xl p-6 md:p-8" style={{ background: C.mint }} data-testid="tablero-capa3">
      <div className="text-[10px] font-bold uppercase tracking-[0.22em]" style={{ color: C.gold }}>Capa 3 · Sistema</div>
      <h2 className="font-display text-xl md:text-2xl font-bold mt-1" style={{ color: C.text }}>¿Qué área de talento arreglo primero?</h2>
      <p className="text-sm mt-2 mb-6" style={{ color: "#5B6B64" }}>
        La madurez de cada área sale de tu informe. Tú indicas cuánto te duele hoy cada una y el tablero cruza ambos datos.
      </p>
      {editing ? (
        <>
          <PainInput dolor={dolor} onChange={(code, n) => setDolor((d) => ({ ...d, [code]: n }))} />
          <button
            onClick={save}
            disabled={!complete || saving}
            className="mt-5 inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold text-white disabled:opacity-40"
            style={{ background: C.green }}
            data-testid="tablero-capa3-save"
          >
            {saving && <Loader2 className="w-4 h-4 animate-spin" />} Ver mis prioridades
          </button>
          {!complete && <span className="ml-3 text-[12px]" style={{ color: "#5B6B64" }}>Responde las 6 áreas para continuar.</span>}
        </>
      ) : (
        <div className="space-y-6">
          <Capa3Matrix result={data.result} />
          <Capa3Cards result={data.result} testId={testId} />
          <button onClick={() => setEditing(true)} className="text-sm font-semibold underline" style={{ color: C.green }} data-testid="tablero-capa3-edit">
            Cambiar mis respuestas
          </button>
        </div>
      )}
    </section>
  );
};
